import { render, staticRenderFns } from "./bkinfo.vue?vue&type=template&id=602f9e7d&scoped=true"
import script from "./bkinfo.vue?vue&type=script&lang=js"
export * from "./bkinfo.vue?vue&type=script&lang=js"
import style0 from "./bkinfo.vue?vue&type=style&index=0&id=602f9e7d&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602f9e7d",
  null
  
)

export default component.exports